import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {t} from 'i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import MobileUserImportService from '../../services/MobileUserImportService';
import ImportLogList from './ImportLogList';

class UserImportList extends BaseListContainer {
    constructor(props) {
        super(props, new MobileUserImportService());
        this.state = {
            list: [],//props.list,
            loading: true,
            size: 0,
            first: 0,
            criteria: props.criteria,
            statusOptions: [],
            roleOptions: [],
            name: props.name,
            expandedRows:[]
        };
        this.onRemoveAction = this.onRemoveAction.bind(this);
        this.userId = this.authService.getUserId();
        this.handleOnRowToggle=this.handleOnRowToggle.bind(this);
    }
    getDataKey() {
        return 'id';
    }

    getListTitle() {
        return 'user.listTitle';
    }

    translate(key) {
        return t(key);
    }

    updateSearchCriteria(criteria) {
        return {
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            roles: criteria.roles,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            email: '',
            firstName: '',
            lastName: '',
            role: undefined,
            id: null,
            firstResult: 0,
            roles: [],
            maxResults: 10,
            sortField: 'createdDateTime',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getCriteriaName() {
        return 'import-log-list-sc';
    }

    getContainerListName() {
        return 'import-log-list-container';
    }

    rowExpansionTemplate(e){
        return(
            <ImportLogList
                userImportId={e.id}
                expandFilters={false}
            />
        );
    }
    handleOnRowToggle(e) {
        this.setState({ expandedRows: e.data })
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='email-sc'
                    name='email'
                    label={t('user.email')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.email}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaTextComponent
                    id='firstName-sc'
                    name='firstName'
                    label={t('user.firstName')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.firstName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaTextComponent
                    id='lastName-sc'
                    name='lastName'
                    label={t('user.lastName')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.lastName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
            </div>
        );
    }

    getList() {
        const { criteria } = this.state;
        const activeElement = document.activeElement;
        this.setState(
            {
                loading: true,
            },
            () => {
                this.service
                    .getUserImportList(criteria)
                    .then((data) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: this.updateListElements(data.content),
                                    loading: false,
                                    size: data.totalElements,
                                },
                                () => {
                                    this.onAfterGetList(data);
                                    this.setTimeout(() => activeElement?.focus(), 50);
                                }
                            );
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: [],
                                    loading: false,
                                    size: 0,
                                },
                                () => {
                                    this.afterGetListError();
                                }
                            );
                        }
                    });
            }
        );
    }

    prepareColumns() {
        return [
            { field: 'createdDateTime', header: 'Data', sortable: true },
            { field: 'userName', header: 'Wykonany przez', sortable: true },
            { field: 'importedCount', header: 'Ilość poprawnie zaimportowanych', sortable: true },
            { field: 'notImportedCount', header: 'Ilość błędów', sortable: true },
        ];
    }
    roleTemplate(rowData) {
        return rowData.roles ? rowData.roles.map((r) => t(`UserRoleType.${r}`)).join(', ') : '';
    }
    breadCrumbItems() {
        return [{name: t('import.historyHeader')}];
    }
    prepareHeaderItems() {
    
    }

    actionTemplate(rowData) {
        return (
            <div>
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenEditDialog(e, rowData.id)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='left'
                    iconSize='mdi-24px'
                    iconColor='blue'
                />
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenRemoveDialog(e, rowData.id)}
                    variant='red'
                    iconName='mdi-trash-can'
                    iconSide='left'
                    iconSize='mdi-24px'
                    iconColor='red'
                    rendered={rowData.id !== this.userId}
                />
            </div>
        );
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.renderView()}
            </div>
        );
    }
    onRemoveAction(callback) {
        this.blockUi();
        this.service
            .remove(this.state.idToRemove)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.unblockUi();
                this.hideDeleteDialog();
            });
    }
}

UserImportList.defaultProps = {
    lazy: true,
};

UserImportList.propTypes = {
    editUrl: PropTypes.string,
    detailsUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserImportList));
